<template>
    <div
        id="lt-yantr"
        class="advanced-calc auto-refinance-calc">
        <div class="container-width b-margin60">
            <div class="advanced-calc-filter">
                <label class="filter-header">Current Loan:</label>
                <ul class="filter-inputs three-col">
                    <li>
                        <number-input
                            v-model="CurrentBalance"
                            :label="labelCurrentBalance"
                            :tooltip-link="tooltipCurrentBalance"
                            inputmode="decimal"
                        />
                    </li>
                    <li>
                        <number-input
                            v-model="MonthlyPayment"
                            :label="labelMonthlyPayment"
                            inputmode="decimal"
                        />
                    </li>
                    <li>
                        <number-input
                            v-model="CurrentInterestRate"
                            :label="labelInterestRate"
                            symbol="%"
                            symbol-aligned="right"
                            precision="3"
                            max-value="100.000"
                            inputmode="decimal"
                        />
                    </li>
                </ul>
                <label class="filter-header">Refinance Loan:</label>
                <ul class="filter-inputs three-col mb-none">
                    <li>
                        <number-input
                            v-model="LoanAmount"
                            :label="labelLoanAmount"
                            inputmode="decimal"
                        />
                    </li>
                    <li>
                        <drop-down
                            v-model="LoanTermInYears"
                            :label="labelLoanTerm"
                            :options="LoanTermInYearsList"
                            :tooltip-link="tooltipLoanTerm"
                        />
                    </li>
                    <li>
                        <number-input
                            v-model="RefinanceInterestRate"
                            :label="labelInterestRate"
                            symbol="%"
                            symbol-aligned="right"
                            precision="3"
                            max-value="100.000"
                            inputmode="decimal"
                        />
                    </li>
                </ul>
            </div>
            <auto-refinance-chart
                :current-balance="CurrentBalance"
                :monthly-payment="MonthlyPayment"
                :current-interest-rate="CurrentInterestRate"
                :loan-amount="LoanAmount"
                :loan-term-in-years="LoanTermInYears"
                :refinance-interest-rate="RefinanceInterestRate"
                :disclosure-text="DisclosureText"
                :disclosure-tokens="DisclosureTokens"
                :lt-logo="LtLogo"
                :destination-link-or-id="DestinationLinkOrId"
                :destination-button-text="DestinationButtonText"
            />
        </div>
    </div>
</template>

<script>
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import LoanTermList from '~/constants/loan-term-list';
    import CreditScoreList from '~/constants/credit-score-list';
    import AutoRefinanceChart from './components/auto-refinance-chart.vue';

    export default {
        components: {
            NumberInput,
            DropDown,
            AutoRefinanceChart,
        },
        props: {
            filterHeader: {
                default: 'Auto Information',
            },
            labelCurrentBalance: {
                default: 'Current Balance:',
            },
            labelMonthlyPayment: {
                default: 'Monthly Payment:',
            },
            labelInterestRate: {
                default: 'Interest Rate:',
            },
            labelLoanAmount: {
                default: 'Loan Amount:',
            },
            labelLoanTerm: {
                default: 'Loan Term:',
            },
            tooltipLoanTerm: {
                default: 'loan-terms',
            },
            currentBalance: {
                default: 45000,
            },
            tooltipCurrentBalance: {
                default: 'current-balance',
            },
            monthlyPayment: {
                default: 650,
            },
            currentInterestRate: {
                default: 3.99,
            },
            refinanceInterestRate: {
                default: 1.99,
            },
            loanAmount: {
                default: 45000,
            },
            loanTermInYears: {
                default: 6,
            },
            ltLogo: {
                default: 0,
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: '',
            },
            destinationLinkOrId: {
                default: 'ns-pp-refinance',
            },
            destinationButtonText: {
                default: 'See Refinance Offers',
            },
        },
        data() {
            return {
                LoanTermInYears: this.loanTermInYears,
                LoanTermInYearsList: LoanTermList.LoanTermInYearsList.autorefinance,
                CreditScoreList: CreditScoreList.autoloan,
                CurrentBalance: this.currentBalance,
                MonthlyPayment: this.monthlyPayment,
                CurrentInterestRate: this.currentInterestRate,
                LoanAmount: this.loanAmount,
                RefinanceInterestRate: this.refinanceInterestRate,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                LtLogo: this.ltLogo,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
            };
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-advanced-filter.scss" lang="scss"></style>
